export const myDocumentsTranslationsEn = {
  MY_DOCUMENTS_USER_FILES_PAGE_TITLE: "Review and management of employee documents",
  MY_DOCUMENTS_UPLOAD_PAGE_TITLE: "Upload documents",
  MY_DOCUMENTS_MISSING_UPLOADERS: "There is no set uploader",
  MY_DOCUMENTS_DELETE_CONFIRM_INFO: "Are you really deleting the document?",
  MY_DOCUMENTS_OPERATOR_GUIDE: "MyDocuments operator manual",
  MY_DOCUMENTS_USER_GUIDE: "MyDocuments user manual",
  MY_DOCUMENTS_VIEWING_DOCUMENTS: "Viewing documents",
  MY_DOCUMENTS_MANAGING_DOCUMENTS: "Managing documents",
  MY_DOCUMENTS_DOCUMENT_NOT_FOUND: "No document uploaded!",
  MY_DOCUMENTS_DOCUMENT_ERROR_DELETION: "Failed to delete document",
  MY_DOCUMENTS_DOCUMENT_SUCCESSFUL_DELETION: "Document was successfully deleted",
  MY_DOCUMENTS_EDIT_DOCUMENT: "Edit document",
  MY_DOCUMENTS_DOCUMENT_UPLOAD_SUCCESSFUL: "File uploaded successfully.",
  MY_DOCUMENTS_DOCUMENT_UPLOAD_FAILED: "File upload failed",
  MY_DOCUMENTS_UPLOAD_DOCUMENT: "Upload document",
  MY_DOCUMENTS_MENU_ALLOWED_INFO: "The Documents menu item in the MyHR menu becomes available to all users",
  MY_DOCUMENTS_NEW_DOCUMENTS: "New Documents",
  MY_DOCUMENTS_UPLOADERS: "Uploader(s)",
  MY_DOCUMENTS_UPLOADER: "Uploader",
  MY_DOCUMENTS_UPLOADED: "Uploaded",
  MY_DOCUMENTS_SIZE: "Size",
  MY_DOCUMENTS_FILE_NAME: "File name",
  MY_DOCUMENTS_EMPLOYEE_VISIBILITY: "An employee can see it",
  MY_DOCUMENTS_EMPLOYEE_UNVISIBILITY: "An employee can't see it",
  MY_DOCUMENTS_DOCUMENTS: "Documents",
  MY_DOCUMENTS_MASS_UPLOAD: "MassUpload",
  MY_DOCUMENTS_MASS_UPLOAD_TITLE: "MassDocument Upload",
  MY_DOCUMENTS_MASS_INSTRUCTIONS_TITLE: "Usage Instructions",
  MY_DOCUMENTS_MASS_INSTRUCTIONS_TEXT: "Upload multiple documents for different employees at once. Include the identifier (contract code) in the filenames.\nSupported formats: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG, GIF.\nMaximum file size: 9MB.",
  MY_DOCUMENTS_MASS_FILENAME_FORMAT: "Filename format: {identifier}_{description}.{extension} (e.g. 12345_employment_contract.pdf)",
  MY_DOCUMENTS_MASS_DROP_TEXT: "Drag files here or click to browse (max 50 files)",
  MY_DOCUMENTS_SELECTED_FILES: "Selected files",
  MY_DOCUMENTS_REMOVE_ALL: "Remove all",
  MY_DOCUMENTS_NO_DESCRIPTION: "No description",
  MY_DOCUMENTS_UPLOADING_FILES: "Uploading files",
  MY_DOCUMENTS_PROCESSING_FILES: "Processing files...",
  MY_DOCUMENTS_SUCCESSFUL_UPLOADS: "Successful uploads",
  MY_DOCUMENTS_FAILED_UPLOADS: "Failed uploads",
  MY_DOCUMENTS_UPLOAD_FILES: "Upload files",
  MY_DOCUMENTS_UNKNOWN_ERROR: "Unknown error",
  MY_DOCUMENTS_ERROR_INVALID_FORMAT: "Invalid filename format (format: {identifier}_{description}.pdf)",
  MY_DOCUMENTS_ERROR_INVALID_LENGTH: "Identifier length is invalid (exactly 5 characters required)",
  MY_DOCUMENTS_ERROR_ID_NOT_FOUND: "Identifier not found in database",
  MY_DOCUMENTS_ERROR_UNSUPPORTED_TYPE: "Unsupported file type",
  MY_DOCUMENTS_MASS_TOO_MANY_FILES: "Too many files (maximum 50 files allowed)",
  MY_DOCUMENTS_MASS_NO_VALID_FILES: "No valid files to upload",
  MY_DOCUMENTS_MASS_UPLOAD_ALL_SUCCESS: "{{count}} files uploaded successfully",
  MY_DOCUMENTS_MASS_UPLOAD_ALL_FAILED: "{{count}} files failed to upload",
  MY_DOCUMENTS_MASS_UPLOAD_PARTIAL: "{{success}} files successful, {{failed}} failed",
  MY_DOCUMENTS_MASS_UPLOAD_ERROR: "An error occurred during upload",
  MY_DOCUMENTS_FAILED_FILES: "Failed files",
  MY_DOCUMENTS_MASS_UPLOAD_HISTORY: "Mass uploaded files",
  MY_DOCUMENTS_UPLOADED_FILES: "Uploaded files",
  MY_DOCUMENTS_NO_FILES: "No files",
  MY_DOCUMENTS_UPLOADED_AT: "Upload date",
  MY_DOCUMENTS_FILE_COUNT: "File count",
  MY_DOCUMENTS_DELETE_MASS_UPLOAD_CONFIRM_INFO: "Are you sure you want to delete all uploaded documents?",
};
